export default __webpack_public_path__ + "38be4d54b88a998d62cf0b40e838a5ef.svg";